var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAwesomeHospital = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.031,
    height: 16.036,
    viewBox: "0 0 14.031 16.036",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-hospital",
    "data-name": "Icon awesome-hospital",
    d: "M14.031,15.409v.626H0v-.626a.376.376,0,0,1,.376-.376H1V3.758a.752.752,0,0,1,.752-.752H4.51V.752A.752.752,0,0,1,5.262,0H8.77a.752.752,0,0,1,.752.752V3.007h2.756a.752.752,0,0,1,.752.752V15.033h.626A.376.376,0,0,1,14.031,15.409Zm-4.385-9.4H8.394a.376.376,0,0,0-.376.376V7.642a.376.376,0,0,0,.376.376H9.646a.376.376,0,0,0,.376-.376V6.389A.376.376,0,0,0,9.646,6.013Zm-5.262,2H5.638a.376.376,0,0,0,.376-.376V6.389a.376.376,0,0,0-.376-.376H4.385a.376.376,0,0,0-.376.376V7.642A.376.376,0,0,0,4.385,8.018Zm3.257,4.009H6.389a.376.376,0,0,0-.376.376v2.631h2V12.4A.376.376,0,0,0,7.642,12.027Zm2-3.007H8.394a.376.376,0,0,0-.376.376v1.253a.376.376,0,0,0,.376.376H9.646a.376.376,0,0,0,.376-.376V9.4A.376.376,0,0,0,9.646,9.02ZM6.013,9.4a.376.376,0,0,0-.376-.376H4.385a.376.376,0,0,0-.376.376v1.253a.376.376,0,0,0,.376.376H5.638a.376.376,0,0,0,.376-.376ZM5.7,3.007h.814v.814a.188.188,0,0,0,.188.188h.626a.188.188,0,0,0,.188-.188V3.007h.814a.188.188,0,0,0,.188-.188V2.192A.188.188,0,0,0,8.331,2H7.517V1.19A.188.188,0,0,0,7.329,1H6.7a.188.188,0,0,0-.188.188V2H5.7a.188.188,0,0,0-.188.188v.626A.188.188,0,0,0,5.7,3.007Z",
    fill: "#0046a7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeHospital);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon awesome-hospital.8523c525e6aa7a64ae63123ab4ff0c99.svg";